export const TOGGLE_VIEW = 'TOGGLE_VIEW';
